import AdornmentSelect from '@/components/Selects/AdornmentSelect';
import { getLanguageFlagSrcByLocale } from '@/pages/AdvancedEditor/components/panels/script/utils';
import { allowedLanguages, SupportedLanguage } from '@/utils/types';
import styled from '@emotion/styled';

const languageToLocale: Record<SupportedLanguage, string> = {
    english: 'en-us',
    spanish: 'es-es',
    italian: 'it-it',
    swedish: 'sv-se',
    german: 'de-de',
    french: 'fr-fr',
    dutch: 'nl-nl',
    filipino: 'fil-ph',
    portuguese: 'pt-pt',
    turkish: 'tr-tr',
    czech: 'cs-cz',
    croatian: 'hr-hr',
    indonesian: 'id-id',
    polish: 'pl-pl',
    romanian: 'ro-ro',
    danish: 'da-dk',
    slovak: 'sk-sk',
    malay: 'ms-my',
};

export const languageScriptMap: Record<SupportedLanguage, string> = {
    english: 'Latin',
    spanish: 'Latin',
    italian: 'Latin',
    swedish: 'Latin',
    german: 'Latin',
    french: 'Latin',
    dutch: 'Latin',
    filipino: 'Latin',
    portuguese: 'Latin',
    turkish: 'Latin',
    czech: 'Latin',
    croatian: 'Latin',
    indonesian: 'Latin',
    polish: 'Latin',
    romanian: 'Latin',
    danish: 'Latin',
    slovak: 'Latin',
    malay: 'Latin',
};

const StartIcon = styled.img`
    height: 12px;
    margin-right: 4px;
`;

function getStartAdornment(value: SupportedLanguage): JSX.Element {
    const flagSrc = languageToLocale[value] ? getLanguageFlagSrcByLocale(languageToLocale[value]) : null;
    return flagSrc ? <StartIcon src={flagSrc} alt={value} /> : <></>;
}

const StyledAdornmentSelect = styled(AdornmentSelect<SupportedLanguage>)`
    width: 200px;

    & .MuiInputBase-root {
        padding-top: 3px;
        padding-bottom: 3px;
    }

    & .MuiInputBase-input {
        font-size: 1.4rem;
        text-transform: capitalize;
    }

    & .MuiOutlinedInput-notchedOutline {
        border-radius: 8px;
        border-color: ${({ theme }) => theme.colors.black[300]};
    }
`;

interface Props {
    value: SupportedLanguage;
    onChange: (value: SupportedLanguage) => void;
    id?: string;
    className?: string;
}

export const LanguageSelect = ({ value, onChange, id = '', className }: Props) => {
    return (
        <StyledAdornmentSelect
            id={id}
            label=""
            className={className}
            options={[...allowedLanguages]}
            getOptionLabel={option => option as string}
            value={value}
            optionSx={{ fontSize: '1.4rem', textTransform: 'capitalize' }}
            onChange={(_, value) => {
                if (!value) return;
                onChange(value);
            }}
            getStartAdornment={value => getStartAdornment(value as SupportedLanguage)}
            disableClearable
        />
    );
};
